import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES, menuHref } from '../data/siteStructure';

const byKey = (cat, keys) => keys.map((k) => CATEGORIES.find((c) => c.key === cat).services.find((s) => s.key === k));
const item = (s, label) => ({ to: menuHref(s), label: label || s.label, key: s.key });

// Solo servizi: la vendita si raggiunge da footer e SalesBanner
export const MENU = [
  {
    key: 'servizi', label: 'Servizi', columns: [
      { title: 'Casa', items: [...byKey('casa', ['divani', 'tappezzeria', 'materassi', 'tappeti']).map((s) => item(s)), { to: '/servizi', label: 'Vedi tutti i servizi casa', key: 'tutti-casa', strong: true }] },
      { title: 'Veicoli', items: byKey('veicoli', ['auto', 'moto', 'camper', 'barche', 'aerei', 'bus']).map((s) => item(s, s.key === 'auto' ? 'Auto / Detailing' : s.key === 'bus' ? 'Flotte e Bus' : undefined)) },
    ],
  },
  { key: 'aziende', label: 'Aziende', columns: [{ items: [
    ...byKey('aziende', ['flotte', 'hotel', 'ristoranti', 'vetrate']).map((s) => item(s, s.key === 'ristoranti' ? 'Ristoranti & Locali' : undefined)),
    { to: '/servizi-aziende', label: 'Vedi tutti i servizi aziende', key: 'tutti-aziende', strong: true },
  ] }] },
  { key: 'azienda', label: 'Azienda', columns: [{ items: [
    { to: '/chi-siamo', label: 'Chi Siamo', key: 'chi-siamo' },
    { to: '/come-funziona', label: 'Come Funziona', key: 'come-funziona' },
    { to: '/tecnologia-fortador-vapore-lamborghini', label: 'Tecnologia Fortador', key: 'tecnologia' },
    { to: '/blog', label: 'Blog', key: 'blog' },
  ] }] },
];

const linkCls = 'block px-3 py-2 rounded-lg text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors';

const Panel = ({ m, close }) => (
  <div className="absolute left-0 top-full pt-2 z-50">
    <div className={`bg-white rounded-xl shadow-xl border border-gray-100 p-3 ${m.columns.length > 1 ? 'grid grid-cols-2 gap-4 w-[30rem]' : 'w-64'}`} data-testid={`menu-panel-${m.key}`}>
      {m.columns.map((col) => (
        <div key={col.title || m.key}>
          {col.title && <p className="px-3 pb-1 text-xs font-bold uppercase tracking-wide text-gray-400">{col.title}</p>}
          <ul>
            {col.items.map((i) => (
              <li key={i.key}><Link to={i.to} className={`${linkCls} ${i.strong ? 'font-semibold text-green-700' : ''}`} onClick={close} data-testid={`menu-link-${i.key}`}>{i.label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </div>
);

export const DesktopMenu = () => {
  const [open, setOpen] = useState(null);
  return (
    <div className="hidden lg:flex items-center gap-1" onMouseLeave={() => setOpen(null)} data-testid="desktop-menu">
      {MENU.map((m) => (
        <div key={m.key} className="relative" onMouseEnter={() => setOpen(m.key)}>
          <button type="button" onClick={() => setOpen(open === m.key ? null : m.key)} aria-expanded={open === m.key} data-testid={`menu-${m.key}`}
            className="text-sm font-medium px-3 py-2 rounded text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors">
            {m.label} <span aria-hidden="true">▾</span>
          </button>
          {open === m.key && <Panel m={m} close={() => setOpen(null)} />}
        </div>
      ))}
      <Link to="/contatti" className="text-sm font-medium px-3 py-2 rounded text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors" data-testid="menu-contatti">Contatti</Link>
    </div>
  );
};

export const MobileMenu = () => {
  const [open, setOpen] = useState(null);
  return (
    <div className="space-y-1" data-testid="mobile-menu-list">
      {MENU.map((m) => (
        <div key={m.key}>
          <button type="button" onClick={() => setOpen(open === m.key ? null : m.key)} aria-expanded={open === m.key} data-testid={`mobile-menu-${m.key}`}
            className="w-full flex justify-between items-center py-3 px-4 rounded-lg font-medium text-gray-700 hover:bg-gray-50">
            {m.label}<span aria-hidden="true">{open === m.key ? '−' : '+'}</span>
          </button>
          {open === m.key && m.columns.map((col) => (
            <div key={col.title || m.key} className="pl-6 pb-2">
              {col.title && <p className="px-3 pt-1 text-xs font-bold uppercase text-gray-400">{col.title}</p>}
              <ul>{col.items.map((i) => <li key={i.key}><Link to={i.to} className={linkCls} data-testid={`mobile-menu-link-${i.key}`}>{i.label}</Link></li>)}</ul>
            </div>
          ))}
        </div>
      ))}
      <Link to="/contatti" className="block py-3 px-4 rounded-lg font-medium text-gray-700 hover:bg-gray-50" data-testid="mobile-menu-contatti">Contatti</Link>
    </div>
  );
};
